import * as React from 'react'
import * as AppStore from './../../state/app-store'
import { Alert, Button, Group, Loader, Textarea } from '@mantine/core'
import { useForm } from '@mantine/form'
import { IconAlertCircle, IconCheck } from '@tabler/icons-react'
import { useMutation } from '@apollo/client'
import { useRouter } from 'next/router'

import * as Types from '../../declarations'
import * as GQLQueries from '../../lib/queries'
import * as Selectors from './../../state/selectors'

const TextFeedback = ({ version }: { version: Types.VERSION }) => {
	const [suggestEdits, { loading: isSubmitting }] = useMutation(
		GQLQueries.Mutations.SuggestEdit,
	)
	const [isSuccess, setIsSuccess] = React.useState<boolean | undefined>(
		undefined,
	)

	const router = useRouter()
	const { asPath } = router

	const authedUser = AppStore.useAppSelector(Selectors.authedUser)

	const feedbackForm = useForm({
		initialValues: {
			suggestion: '',
		},
		validate: {
			suggestion: (value) =>
				value
					? null
					: 'Please enter a suggestion, something that could be changed, added, or removed',
		},
	})

	const onSubmit = async (values: { suggestion: string }) => {
		setIsSuccess(undefined)

		try {
			const { suggestion } = values
			const response = await suggestEdits({
				variables: {
					userId: authedUser?.id,
					page: asPath,
					site: version,
					suggestion,
				},
			})

			const success = response?.data?.suggestEdit ?? false
			setIsSuccess(success)

			if (success) {
				feedbackForm.reset()
			}
		} catch {
			setIsSuccess(false)
		}
	}

	const isSendable = feedbackForm.isValid()

	return (
		<>
			<form onSubmit={feedbackForm.onSubmit((values) => onSubmit(values))}>
				<Textarea
					minRows={6}
					withAsterisk
					label="Suggest an edit"
					placeholder="What could be improved / added?"
					{...feedbackForm.getInputProps('suggestion')}
					style={{ marginBottom: '10px' }}
				/>

				{isSuccess && (
					<Alert
						icon={<IconCheck size="1rem" />}
						title="Suggestion received"
						color="green"
					>
						<p>
							Thank you for sharing, your suggestion will be reviewed shortly.
						</p>
						{/* <p>
							If you have time,{' '}
							<a
								href="https://forms.gle/e6YN6ZM4LVvnZaAE9"
								target="_blank"
								rel="noreferrer"
							>
								answering this survey
							</a>{' '}
							would also be very helpful.
						</p> */}
					</Alert>
				)}
				{isSuccess === false && (
					<Alert
						icon={<IconAlertCircle size="1rem" />}
						title="🤦‍♂️ Something went wrong"
						color="red"
					>
						suggestion wasn&apos;t sent 🤷‍♂️
					</Alert>
				)}

				<Group justify="right" mt="md">
					<Button disabled={!isSendable || isSubmitting} type="submit">
						{isSubmitting ? (
							<>
								Sending&nbsp;&nbsp;&nbsp;
								<Loader size="sm" variant="dots" color="gray" />
							</>
						) : isSendable ? (
							'Send suggestion'
						) : (
							'Send'
						)}
					</Button>
				</Group>
			</form>
		</>
	)
}

export default TextFeedback
